<template lang="pug">
  b-form-checkbox(
    v-model="patientReachedOnCall",
    :value="true",
    :unchecked-value="false",
    @change="$emit('input', { patientReachedOnCall: $event })"
  ) I reached the patient on phone and explained which tasks are due.
</template>

<script>
export default {
  data() {
    return {
      patientReachedOnCall: this.value.patientReachedOnCall === true,
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
}
</script>
